import classesCss from './Cover.module.css';
import image from '../../Images/Slides/3.jpg'

const Cover = () => {
    return (
        <div className={classesCss.cover}>
            <img src={image} className={classesCss.cover__img}/>
        </div>
    );
};

export default Cover;